/**
 * Quitter un salon, proprement et d'un seul endroit.
 *
 * La sequence etait recopiee dans trois ecrans, et le bouton RETOUR du
 * navigateur, lui, n'en faisait aucune : on revenait a l'accueil en restant
 * ASSIS a la table, invisible pour soi-meme, et la partie attendait un joueur
 * qui ne voyait plus rien. Un depart doit toujours faire les quatre gestes.
 */
import { connection } from './connection.js';
import { useRoomStore } from '../store/roomStore.js';

export function leaveRoom(options: { notify?: boolean } = {}): void {
  // `notify: false` quand la place est deja perdue (entree refusee, salon
  // disparu) : il n'y a personne a prevenir, et le message partirait dans le
  // vide.
  if (options.notify !== false) connection.send({ type: 'leave' });
  connection.clearSession();
  useRoomStore.getState().reset();
}
